import { useStore } from 'react-admin';
import { Box, Button, ButtonGroup } from '@mui/material';
import ViewListIcon from '@mui/icons-material/ViewList';
import ViewModuleIcon from '@mui/icons-material/ViewModule';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import { MissionList } from './list/MissionList';
import { MissionGrid } from './grid/MissionGrid';
import { MissionCalendar } from './calendar/MissionCalendar';

type MissionTabView = 'list' | 'grid' | 'calendar';

export const MissionTab = () => {
    const [missionTabView, setMissionTabView] = useStore<MissionTabView>(
        'missionTabView',
        'list'
    );

    return (
        <Box>
            <Box display="flex" justifyContent="flex-end" mb={2}>
                <ButtonGroup size="small" variant="outlined">
                    <Button
                        onClick={() => setMissionTabView('list')}
                        startIcon={<ViewListIcon />}
                        variant={
                            missionTabView === 'list' ? 'contained' : 'outlined'
                        }
                    >
                        List
                    </Button>
                    <Button
                        onClick={() => setMissionTabView('grid')}
                        startIcon={<ViewModuleIcon />}
                        variant={
                            missionTabView === 'grid' ? 'contained' : 'outlined'
                        }
                    >
                        Grid
                    </Button>
                    <Button
                        onClick={() => setMissionTabView('calendar')}
                        startIcon={<CalendarMonthIcon />}
                        variant={
                            missionTabView === 'calendar'
                                ? 'contained'
                                : 'outlined'
                        }
                    >
                        Calendar
                    </Button>
                </ButtonGroup>
            </Box>

            <Box sx={{ width: '100%', marginTop: '-20px' }}>
                {missionTabView === 'list' && <MissionList />}
                {missionTabView === 'grid' && <MissionGrid />}
                {missionTabView === 'calendar' && <MissionCalendar />}
            </Box>
        </Box>
    );
};
